import { colors } from '@styles/vars'
import { debounce } from 'lodash'
import React from 'react'
import { useCallback } from 'react'
import { useState } from 'react'
import { useRef } from 'react'
import styled from 'styled-components'
import Button from './Button'
import EmphasizedContent from './EmphasizedContent'

export default function Clipboard({ value }: Props) {
    const [copied, setCopied] = useState(false)
    const inputRef = useRef<HTMLInputElement | null>(null)
    const { current: revert } = useRef(debounce(() => setCopied(false), 3000)) // reverts state in 3s

    const copy = async () => {
        if (!inputRef.current)
            return
        
        select()

        try {
            navigator.clipboard.writeText(inputRef.current.value)
        } catch {
            document.execCommand('copy')    
        }

        setCopied(true)
        revert()
    }

    const select = () => {
        if (!inputRef.current)
            return

        inputRef.current.focus()
        inputRef.current.select()
    }

    return (
        <ClipboardWrapper>
            <Input ref={inputRef} value={value} onChange={e => e.preventDefault()} onClick={select} />
            <Button onClick={copy}>Copy</Button>
            {copied && <SuccessMessage>Copied!</SuccessMessage>}
        </ClipboardWrapper>
    )
}

const ClipboardWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    grid-column-gap: 15px;
    grid-row-gap: 5px;
`

const Input = styled.input`
    width: 100%;
    height: 54px;
    color: ${colors.black};
    transition: .2s ease-out;
    padding: 0 15px;
    border-radius: 5px;
    border: 0;
    font-weight: 600;
    background: ${colors.greyBackground};
    border: 1px solid ${colors.border};
    transition: .2s ease-out;

    &:focus {
        outline: none;
    }
`

const SuccessMessage = styled.small`
    grid-column: 1 / 3;
`

interface Props {
    value: string
}